import { Link, useParams } from "react-router-dom";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./style.scss";

function DoctorProfile () {
    const { category } = useParams();
    const [doctors, setDoctors] = useState([]);
    const [doctor, setDoctor] = useState(null);
    const { doctorId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        fetch("/DoctorsData.json")
            .then((response) => response.json())
            .then((data) => {
                const doctorsFromCategory = data[category?.toLowerCase()];
                if (!doctorsFromCategory || doctorsFromCategory.length === 0) {
                    navigate("/nem-talalhato"); // Átnavigálunk, ha nincs ilyen kategória
                } else {
                    setDoctors(doctorsFromCategory);
                }
            })
            .catch((error) => console.error("Hiba történt az adatok betöltésekor:", error));
    }, [category, navigate]);

    const openScreen = (id) => {
        navigate(`/doctor/${id}`);
    };

    if (!doctors.length) {
        return null; // addig ne rendereljen semmit, amíg betölt vagy navigál
    }

    

    // Dinamikusan állítjuk be a grid-t, attól függően, hogy hány orvos van
    let gridClass = "feature-grid";
    if (doctors.length === 1) gridClass += " single";
    if (doctors.length === 2) gridClass += " two-doctors";

    const goToPrices = (event,doctor) => {
        event.stopPropagation();
        navigate(`/prices?doctor=${encodeURIComponent(doctor.name)}`);
    };


    return (
        <section className="doctor-profile">
            <div className="container">
                <h1 className="title">
                    {category === "plasztikai sebészet"
                        ? doctors[0]?.id
                        : category.charAt(0).toUpperCase() + category.slice(1)
                    }
                </h1>
                <div className={gridClass}>
                    {doctors.map((doctor) => (
                        <div className="feature" key={doctor.id} onClick={() => openScreen(doctor.id)}>
                            <img
                                src={doctor.image}
                                alt={doctor.name}
                                className="profile-image"
                                style={{ objectPosition: doctor.customPosition || "center" }}
                            />
                            <h2 className="headline">{doctor.name}</h2>
                            <p className="description">{doctor.title}</p>
                            <p className="company"> {doctor.company} </p>
                            <div className="button-row">
                                <Link to={`/doctor/${doctor.id}`}>
                                    <button className="button">Bejelentkezés</button>
                                </Link>
                                <button className='button price' onClick={(e) => goToPrices(e, doctor)}>
                                    Áraink
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default DoctorProfile;